import { render, staticRenderFns } from "./dependent-vendors-modal-list.vue?vue&type=template&id=03ddb1ca&scoped=true&"
import script from "./dependent-vendors-modal-list.vue?vue&type=script&lang=js&"
export * from "./dependent-vendors-modal-list.vue?vue&type=script&lang=js&"
import style0 from "./dependent-vendors-modal-list.vue?vue&type=style&index=0&id=03ddb1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddb1ca",
  null
  
)

export default component.exports